import { default as React, FC } from "react";
import { StyledParagraph } from "./styled.paragraphs";

/**
 * Paragraph Comp. Use lie standard html ``<p>`` element but in uppercase ``<P>``
 */
export const P: FC = ({ children }) => {
  return <StyledParagraph>{children}</StyledParagraph>;
};
